import { graphql } from "@/api/graphql/types/gql";

export const InviteAgentMutation = graphql(`
  mutation InviteAgent($request: AccountsMsInviteSupportUserRequest) {
    AccountsMsInviteSupportUser(request: $request) {
      id
    }
  }
`);
